import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

import { useConfig } from '../../hooks';
import { useStores } from '../../stores';
import { sanitizeHTML } from '../../utilities';
import ButtonBase from '../ButtonBase';
import IconStar from '../Icons/Star';
import List from '../List';
import ListItemIcon from '../ListItemIcon';
import Scrollbar from '../Scrollbar';

const ListConten = ({ data, isTopFrequentQuestions }) => {
  const {
    window: { colors },
    scrollBar
  } = useConfig();

  const { bot } = useStores();
  const { t, i18n } = useTranslation();

  return (
    <ListContainer>
      <StyledScrollbar
        renderView={({ style, ...props }) => {
          return (
            <ScrollbarView
              {...props}
              style={{
                ...style,
                overflowX: 'hidden',
                bottom: '20px',
                top: 0
              }}
            />
          );
        }}
        autoHide={false}
        {...scrollBar}
      >
        <ListWrapper>
          {data.map(item => {
            return (
              <ListItem key={item.text} isTopFrequentQuestions={isTopFrequentQuestions}>
                <ListButton
                  type="button"
                  onClick={() => {
                    if (isTopFrequentQuestions) {
                      return bot.runInfoSequence({
                        MesId: item.mesId,
                        MessageText: item.text,
                        SourceLanguage: i18n.language
                      });
                    }

                    return bot.askQuestion({
                      Question: t(item.text).trim(),
                      TextLanguage: i18n.language
                    });
                  }}
                  isTopFrequentQuestions={isTopFrequentQuestions}
                  accentColor={colors.accent}
                >
                  {isTopFrequentQuestions ? (
                    <>
                      <ListItemIcon>
                        <IconStar viewBox="0 0 576 512" fill="#ffc35e" />
                      </ListItemIcon>

                      <span
                        dangerouslySetInnerHTML={{
                          __html: sanitizeHTML(item.text)
                        }}
                      />
                    </>
                  ) : (
                    t(item.text)
                  )}
                </ListButton>
              </ListItem>
            );
          })}
        </ListWrapper>
      </StyledScrollbar>
    </ListContainer>
  );
};

ListConten.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      mesId: PropTypes.number
    })
  ).isRequired,
  isTopFrequentQuestions: PropTypes.bool
};

ListConten.defaultProps = {
  isTopFrequentQuestions: false
};

const ListContainer = styled(List)`
  position: relative;
  flex: 1 0 auto;
  height: 110px;
`;

const StyledScrollbar = styled(Scrollbar)`
  height: 100%;
`;

const ScrollbarView = styled.div``;

const ListWrapper = styled.div`
  padding-right: 8px;
`;

const ListItem = styled.div`
  padding-bottom: ${props => (!props.isTopFrequentQuestions ? '4px' : 0)};
  font-size: 12px;
  line-height: 1.5;
  border-bottom: ${props => (!props.isTopFrequentQuestions ? '1px solid #e3e3e3' : 'none')};

  &:not(:last-of-type) {
    margin-bottom: 8px;
  }
`;

const ListButton = styled(ButtonBase)`
  position: relative;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;

  &:hover {
    color: ${props => props.accentColor};
    & svg {
      fill: #ffc35e;
    }
  }

  ${({ isTopFrequentQuestions, accentColor }) =>
    !isTopFrequentQuestions &&
    css`
      padding-left: 10px;
      font-weight: 400;
      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 9px;
        width: 4px;
        height: 4px;
        background: ${accentColor};
        border-radius: 50%;
        transform: translateY(-50%);
      }
    `}
`;

export default ListConten;
